import React, { useState } from 'react';
import axios from 'axios';
import Captcha from './Captcha'; 

const VisaCheck = () => {
    // 👇 --- API CONNECTION SETTINGS --- 👇
    // 1. FOR LOCAL TESTING (Uncomment this):
    // const API_BASE_URL = "http://localhost:5000";
    
    // 2. FOR DEPLOYMENT (Uncomment this):
    const API_BASE_URL = "https://backend-new-steel-theta.vercel.app";
    
    const [refNum, setRefNum] = useState('');
    const [visaData, setVisaData] = useState(null);
    const [error, setError] = useState('');

    // --- CAPTCHA STATE ---
    const [captchaInput, setCaptchaInput] = useState('');
    const [realCaptchaCode, setRealCaptchaCode] = useState('');
    const [refreshCaptcha, setRefreshCaptcha] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        setError('');
        setVisaData(null);

        // 1. CAPTCHA CHECK
        if (captchaInput.toLowerCase() !== realCaptchaCode.toLowerCase()) {
            setError('❌ Invalid CAPTCHA Code! Please try again.');
            setRefreshCaptcha(!refreshCaptcha);
            setCaptchaInput('');
            return;
        }

        try {
            const res = await axios.get(`${API_BASE_URL}/api/visa/${refNum.trim()}`);
            setVisaData(res.data);
            
            setCaptchaInput('');
            setRefreshCaptcha(!refreshCaptcha);

        } catch (err) {
            setError('No Record Found! Please check the reference number.');
            setRefreshCaptcha(!refreshCaptcha);
            setCaptchaInput('');
        }
    };

    // Helper to determine status color (Matching the image style)
    const getStatusStyle = (status) => {
        if (!status) return { color: '#000', fontWeight: 'bold' };
        const lowerStatus = status.toLowerCase();
        
        // Exact match for the red text in screenshot
        if (lowerStatus.includes('cancel') || lowerStatus.includes('reject')) {
            return { color: '#d9534f', fontWeight: 'bold' }; // Bootstrap Red
        }
        if (lowerStatus.includes('approv')) {
            return { color: '#5cb85c', fontWeight: 'bold' }; // Bootstrap Green
        }
        return { color: '#000', fontWeight: 'bold' };
    };

    return (
        <div className="container mt-5 mb-5" style={{maxWidth: '900px', minHeight: '60vh'}}>
            {/* Header Section */}
            <div className="text-white py-3 px-4" style={{backgroundColor: '#0055a5'}}>
                <div className="d-flex justify-content-between align-items-center">
                   <span className="small">FOREIGN AFFAIRS AND EUROPEAN INTEGRATION</span>
                </div>
                <div className="small">REPUBLIC OF MOLDOVA</div>
            </div>

            {/* Navigation Bar */}
            <div className="d-flex text-white text-center small fw-bold" style={{backgroundColor: '#004080'}}>
                <div className="flex-fill py-2 bg-primary">CHECK STATUS</div>
            </div>

            <div className="card shadow-sm border-0 mt-4">
                <div className="card-body p-4">
                    
                    {/* Search Form (Hidden if data is found) */}
                    {!visaData && (
                        <div className="text-center">
                            <h3 className="mb-4" style={{color: '#003366', fontFamily: 'serif'}}>Check Application Status</h3>
                            <form onSubmit={handleSearch} className="mb-5" style={{maxWidth: '500px', margin: '0 auto'}}>
                                <div className="mb-3">
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg text-center" 
                                        placeholder="Reference Number (e.g. NCSZVF...)" 
                                        value={refNum}
                                        onChange={(e) => setRefNum(e.target.value)}
                                        required 
                                    />
                                </div>

                                {/* Captcha Section */}
                                <div className="mb-4 p-3 bg-light border rounded">
                                    <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
                                        <Captcha 
                                            onCodeGenerated={(code) => setRealCaptchaCode(code)} 
                                            refreshTrigger={refreshCaptcha} 
                                        />
                                        <button 
                                            type="button" 
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => setRefreshCaptcha(!refreshCaptcha)}
                                        >
                                            ↻
                                        </button>
                                    </div>
                                    <input 
                                        type="text" 
                                        className="form-control text-center fw-bold mx-auto" 
                                        style={{maxWidth: '200px'}}
                                        placeholder="Enter Security Code"
                                        value={captchaInput}
                                        onChange={(e) => setCaptchaInput(e.target.value)}
                                        maxLength={6}
                                        required
                                    />
                                </div>

                                <button className="btn btn-primary px-5 py-2 fw-bold" style={{backgroundColor: '#0055a5'}} type="submit">
                                    Check Status
                                </button>
                            </form>
                            {error && <div className="alert alert-danger">{error}</div>}
                        </div>
                    )}

                    {/* === EXACT ID CARD LAYOUT MATCHING IMAGE === */}
                    {visaData && (
                        <div>
                            {/* Heading "Visa Found" above the box */}
                            <div className="mb-1 fw-bold text-dark" style={{fontSize: '14px', borderBottom: '1px solid #eee', paddingBottom: '5px'}}>
                                Visa Found
                            </div>
                            
                            {/* Light Blue Box Container */}
                            <div className="p-3 mt-2 " style={{
                                backgroundColor: '#d9edf7', // Exact light blue from screenshot
                                border: '1px solid black', // Exact border color
                                color: '#31708f', // Base text color for this theme
                                borderRadius: '4px',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '50%',
                                width: '50%',
                                gap: '15px'

                                

                            }}> 
                           < div >
                                <div className="row">
                                    
                                    {/* Left Side: Photo */}
                                    <div className="w-20px col-md-3 col-sm-12 mb-3 mb-md-0">
                                        <img 
                                            src={visaData.photoUrl || "https://via.placeholder.com/150?text=No+Photo"} 
                                            className="img-fluid" 
                                            alt="Applicant" 
                                            style={{
                                                width: '132px', 
                                                height: '119px', 
                                                objectFit: 'cover',
                                                maxHeight: '190px',
                                                border: '1px solid #000000',
                                                padding: '2px',
                                                backgroundColor: 'white'
                                                
                                            }}
                                        />
                                        <div>

                                            
                                        </div>
                                    </div>

                                    {/* Right Side: Text Details - Color black to match text inside card */}
                                    <div className="col-md-9 col-sm-12 text-start" style={{fontSize: '15px', lineHeight: '1.4', fontFamily: 'Arial, sans-serif', color: '#333'}}>
                                        
                                        {/* Surname */}
                                        <div className="mb-1">
                                            <span className="fw-bold">Surname:</span> <span className="fw-bold text-uppercase">{visaData.surname}</span>
                                        </div>

                                        {/* First Name */}
                                        <div className="mb-1">
                                            <span className="fw-bold">First Name:</span> <span className="fw-bold text-uppercase">{visaData.firstName}</span>
                                        </div>

                                        {/* Date of Birth */}
                                        <div className="mb-1">
                                            <span className="fw-bold">Date of Birth:</span> <span className="fw-bold">{visaData.dob}</span>
                                        </div>

                                        {/* Citizenship */}
                                        <div className="mb-1">
                                            <span className="fw-bold">Citizenship:</span> <span className="fw-bold text-uppercase">{visaData.country}</span>
                                        </div>

                                        {/* Passport Number */}
                                        <div className="mb-2">
                                            <span className="fw-bold">Passport Number:</span> <span className="fw-bold text-uppercase">{visaData.passportNumber}</span>
                                        </div>

                                        {/* Visa Status (Red Label & Value) */}
                                      

                                       

                                    </div>
                                </div>
                                <div >
                                      <div className="mb-1">
                                            <span className="fw-bold" style={{color: '#d9534f'}}>Visa Status: </span> 
                                            <span style={getStatusStyle(visaData.visaStatus)}>{visaData.visaStatus}</span>
                                        </div>

                                        {/* Visa Validity */}
                                        <div className="mb-1">
                                            <span className="fw-bold">Visa Validity:</span> <span className="fw-bold">{visaData.validity}</span>
                                        </div>

                                        {/* Visa Type */}
                                        <div className="mb-1">
                                            <span className="fw-bold">Visa Type:</span> <span className="fw-bold">{visaData.type}</span>
                                        </div>

                                        {/* Purpose */}
                                        <div className="mb-3">
                                            <span className="fw-bold">Purpose of Visit:</span> <span className="fw-bold">{visaData.purpose}</span>
                                        </div>
                                    </div>

                                    </div>
                                     {/* Button inside the box */}
                                        <div className="text-center text-md-start  " >
                                            <button 
                                                className="  btn btn-primary btn-sm px-4 fw-bold" 
                                                style={{
                                                    backgroundColor: '#337ab7', // Specific Blue
                                                    borderColor: '#2e6da4',
                                                    borderRadius: '4px',
                                                    width: '100%',
                                                    maxWidth: '250px',
                                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                                    marginLeft: '15%',
                                                }}
                                                onClick={() => {setVisaData(null); setRefNum('');}}
                                            >
                                                Check Another
                                            </button>
                                        </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VisaCheck;